import { LinearProgress, Tabs as MuiTabs, Stack, styled, Tab } from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import type { FC, MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import type { ContentTone } from "../brand-kit/server/brand-kit-service";
import type { BrandTone } from "../brand-kit/server/brand-tone-service";
import { useGenerateCommsContext } from "./generate-comms-context";

export const CommsTemplateTones: FC<{
  contentTone: ContentTone | "custom";
  onContentToneChange?: (value: ContentTone | "custom") => void;
  selectedBrandTone?: BrandTone | null;
  customBrandTones?: BrandTone[] | null;
  handleClick: (event: MouseEvent<Element>) => void;
}> = ({ contentTone, onContentToneChange, selectedBrandTone, customBrandTones, handleClick }) => {
  const { t } = useTranslation();
  const { text } = useGenerateCommsContext();

  return (
    <Tabs
      value={contentTone ?? "professional"}
      onChange={(_, v: ContentTone | "custom") => {
        onContentToneChange?.(v);
      }}
      variant="scrollable"
      scrollButtons="auto"
    >
      <Tab
        label={<TabLabel loading={text.get("professional")?.loading} name={t("Professional")} />}
        value={"professional"}
      />
      <Tab
        label={<TabLabel loading={text.get("casual")?.loading} name={t("Casual")} />}
        value={"casual"}
      />
      <Tab
        label={<TabLabel loading={text.get("direct")?.loading} name={t("Direct")} />}
        value={"direct"}
      />
      {selectedBrandTone && (
        <Tab
          sx={{ ml: 3 }}
          label={
            <TabLabel
              loading={text.get(selectedBrandTone.summary)?.loading}
              name={selectedBrandTone.name}
            />
          }
          value={"custom"}
          onClick={(e) => {
            customBrandTones && customBrandTones.length > 1 && contentTone === "custom"
              ? handleClick(e)
              : null;
          }}
          icon={customBrandTones && customBrandTones.length > 1 ? <ArrowDropDownIcon /> : <></>}
          iconPosition="end"
        />
      )}
    </Tabs>
  );
};

const Tabs = styled(MuiTabs)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

const TabLabel: FC<{ loading?: boolean | null; name: string }> = ({ loading, name }) => {
  return (
    <Stack>
      {name}
      {loading && <LinearProgress color="inherit" />}
    </Stack>
  );
};
